// Proje API sarmalayıcıları — ProjectDetail/ProjectNew çoğu çağrıyı doğrudan `api()` ile yapar;
// burada yalnız bileşenlerden paylaşılan uçlar durur (TODO-KPI-12 ile açıldı).
import type { Project, ProjectGenerateEstimateResponse, UpdateProjectRequest } from "@mahir/shared";
import { api } from "./client";

/** `PATCH /projects/:id` — kısmi güncelleme; dönen proje JOIN'li tam DTO (kpiSetName dahil). */
export async function updateProject(id: string, body: UpdateProjectRequest): Promise<Project> {
  const res = await api<{ project: Project }>(`/projects/${id}`, { method: "PATCH", body });
  return res.project;
}

/** M17 T3 — `PATCH …/review/sections/:code/kpi-verified` ("Rakamları doğruladım"). */
export async function acknowledgeKpiStale(projectId: string, sectionCode: string): Promise<void> {
  await api<{ ok: true; ackAt: string }>(
    `/projects/${projectId}/review/sections/${encodeURIComponent(sectionCode)}/kpi-verified`,
    { method: "PATCH" },
  );
}

/** Tek bölüm yeniden üretimi (`POST …/generate/section/:code` — GenerateProgress ile aynı uç). */
export async function regenerateSection(projectId: string, sectionCode: string): Promise<void> {
  await api(`/projects/${projectId}/generate/section/${encodeURIComponent(sectionCode)}`, {
    method: "POST",
    body: {},
  });
}

/** Finar 14.7 (K5) — tek bölüm tahmini (`GET …/generate/section/:code/estimate`). */
export type SectionGenerateEstimate = Omit<
  ProjectGenerateEstimateResponse,
  "canGenerate" | "blockerReason"
>;
export async function estimateSection(
  projectId: string,
  sectionCode: string,
): Promise<SectionGenerateEstimate> {
  return api<SectionGenerateEstimate>(
    `/projects/${projectId}/generate/section/${encodeURIComponent(sectionCode)}/estimate`,
  );
}
